import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { faCopy, faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "underscore";
import { ToastContext } from "../../../../context/ToastContext";
import { callautopopulate } from "../../../../services/callautopop";

export const useScreenScheme = ({ filterValues, setFilterValues }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [formValues, setFormValues] = useState({ visible: false, search: "" });
    const [options, setOptions] = useState({});
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const columns = [
        {
            key: "screen_scheme_name",
            label: "Name",
            style: { width: "22%" },
            render: (row) => <div className="py-1">
                <div className="fw-bold text-truncate" style={{ fontSize: "12px" }} title={row?.screen_scheme_name}>{row?.screen_scheme_name}</div>
                <div className="fw-semibold text-truncate" style={{ fontSize: "10px", color: "#a1a1a1" }} title={row?.screen_scheme_description}>{row?.screen_scheme_description}</div>
            </div>
        },
        {
            key: "default_screen_name",
            label: "Default Screen",
            style: { width: "17%" },
            render: (row) => row?.default_screen_name && <div className="text-primary bg-light text-truncate round-small-section" title={row?.default_screen_name} onClick={() => setFilterValues((prev) => ({ ...prev, tab: "screens", config: { screen_id: row?.default_screen_id, screen_name: row?.default_screen_name }, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-link" /> {row?.default_screen_name}</div>
        },
        {
            key: "create_screen_name",
            label: "Create Screen",
            style: { width: "17%" },
            render: (row) => row?.create_screen_name && <div className="text-primary bg-light text-truncate round-small-section" title={row?.create_screen_name} onClick={() => setFilterValues((prev) => ({ ...prev, tab: "screens", config: { screen_id: row?.create_screen_id, screen_name: row?.create_screen_name }, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-link" /> {row?.create_screen_name}</div>
        },
        {
            key: "edit_screen_name",
            label: "Edit Screen",
            style: { width: "17%" },
            render: (row) => row?.edit_screen_name && <div className="text-primary bg-light text-truncate round-small-section" title={row?.edit_screen_name} onClick={() => setFilterValues((prev) => ({ ...prev, tab: "screens", config: { screen_id: row?.edit_screen_id, screen_name: row?.edit_screen_name }, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-link" /> {row?.edit_screen_name}</div>
        },
        {
            key: "view_screen_name",
            label: "View Screen",
            style: { width: "17%" },
            render: (row) => row?.view_screen_name && <div className="text-primary bg-light text-truncate round-small-section" title={row?.view_screen_name} onClick={() => setFilterValues((prev) => ({ ...prev, tab: "screens", config: { screen_id: row?.view_screen_id, screen_name: row?.viewt_screen_name }, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-link" /> {row?.view_screen_name}</div>
        },
        {
            key: "action",
            label: "Action",
            sort: false,
            style: { width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="d-flex gap-3 align-items-center justify-content-center">
                <div className="c-pointer text-primary" title="Work Layout" onClick={() => { setFilterValues((prev) => ({ ...prev, layout: row, apiCall: true })) }}><FontAwesomeIcon icon="fa-solid fa-table-columns" /></div>
                <div className="c-pointer text-primary" title="Edit" onClick={() => { handleEdit(row, false) }}><FontAwesomeIcon icon={faPenToSquare} /></div>
                <div className="c-pointer text-secondary" title="Create Copy" onClick={() => { handleEdit(row, true) }}><FontAwesomeIcon icon={faCopy} /></div>
                <div className="c-pointer text-danger" title="Delete" onClick={() => { setFormValues((prev) => ({ ...prev, isDelete: true, editData: row })) }}><FontAwesomeIcon icon={faTrashCan} /></div>
            </div>
        },
    ]
    const formFields = [
        {
            label: "Screen Scheme Name",
            name: "screen_scheme_name",
            col: "12",
            type: "text",
            required: true,
        },
        {
            label: "Default Screen",
            name: "default_screen",
            col: "12",
            type: "select",
            option: options?.screens,
            required: true,
            hide: formValues?.isCopy
        },
        {
            label: "Create Screen",
            name: "create_screen",
            col: "4",
            type: "select",
            option: options?.screens,
            showClear: true,
            hide: formValues?.isCopy
        },
        {
            label: "Edit Screen",
            name: "edit_screen",
            col: "4",
            type: "select",
            option: options?.screens,
            showClear: true,
            hide: formValues?.isCopy
        },
        {
            label: "View Screen",
            name: "view_screen",
            col: "4",
            type: "select",
            option: options?.screens,
            showClear: true,
            hide: formValues?.isCopy
        },
        {
            label: "Description",
            name: "screen_scheme_description",
            col: "12",
            type: "text",
            required: false,
        },
    ]

    useEffect(() => {
        sessionStorage.removeItem("screens");
        callautopopulate("screens")?.then(res => {
            setOptions((prev) => ({ ...prev, screens: res?.screens?.map(item => { return { ...item, label: item?.screen_name } })?.sort((a, b) => a?.screen_name?.localeCompare(b?.screen_name)) }))
        })
    }, [])

    useEffect(() => {
        (filterValues?.apiCall && _.isEmpty(filterValues?.layout)) && getScreenSchemes();
    }, [filterValues?.apiCall])

    const getScreenSchemes = async () => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            const res = await services.getInvokeRemote("GET", Urls("GETSCREENSCHEMESSUMMARY"), {});
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.screen_schemes_list?.sort((a, b) => a?.screen_scheme_name?.localeCompare(b?.screen_scheme_name));
                setRowData(data);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
            setLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const saveScreenSchemes = async () => {
        try {
            if (!formValues?.screen_scheme_name?.trim() && !formValues?.isDelete) {
                showInfo("Info", "Please enter the screen scheme name");
                return;
            } else if (!formValues?.default_screen && !formValues?.isDelete) {
                showInfo("Info", "Please select a default screen");
                return;
            } else {
                let allScheme = _.pluck(rowData, "screen_scheme_name")?.map(item => item?.toLowerCase());
                if (!_.isEmpty(formValues?.editData) && !formValues?.isCopy) {
                    allScheme = _.filter(allScheme, item => item !== formValues?.editData?.screen_scheme_name?.toLowerCase());
                }
                if (allScheme?.includes(formValues?.screen_scheme_name?.toLowerCase()?.trim())) {
                    showInfo("Info", "This scheme name already exists!");
                    return;
                } else if (!_.isEmpty(formValues?.editData) && (formValues?.editData?.screen_scheme_name?.trim() === formValues?.screen_scheme_name?.trim()) && (formValues?.editData?.screen_scheme_description?.trim() === formValues?.screen_scheme_description?.trim()) && ((formValues?.default_screen?.screen_id || 0) === formValues?.editData?.default_screen_id) && ((formValues?.edit_screen?.screen_id || 0) === formValues?.editData?.edit_screen_id) && ((formValues?.create_screen?.screen_id || 0) === formValues?.editData?.create_screen_id) && ((formValues?.view_screen?.screen_id || 0) === formValues?.editData?.view_screen_id) && !formValues?.isCopy) {
                    showInfo("Info", "No changes made!");
                    return;
                }
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            let payload = {};
            let url = "";
            if (formValues?.isCopy) {
                payload = {
                    source_screen_scheme_id: formValues?.editData?.screen_scheme_id || 0,
                    new_screen_scheme_name: formValues?.screen_scheme_name || "",
                    new_screen_scheme_description: formValues?.screen_scheme_description || ""
                }
                url = "UPSERTSCREENSCHEMESSUMMARYCOPY";
            } else {
                payload = {
                    screen_scheme_id: formValues?.editData?.screen_scheme_id || 0,
                    screen_scheme_name: formValues?.screen_scheme_name || "",
                    screen_scheme_description: formValues?.screen_scheme_description || "",
                    default_screen_id: formValues?.default_screen?.screen_id || 0,
                    edit_screen_id: formValues?.edit_screen?.screen_id || 0,
                    create_screen_id: formValues?.create_screen?.screen_id || 0,
                    view_screen_id: formValues?.view_screen?.screen_id || 0,
                    is_deleted: formValues?.isDelete || false
                }
                url = "UPSERTSCREENSCHEMESSUMMARY"
            }
            const res = await services.getInvokeRemote("POST", Urls(url), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message);
                if (formValues?.isDelete) {
                    setRowData((prev) => [..._.filter(prev, item => item?.screen_scheme_id !== payload?.screen_scheme_id)]);
                } else {
                    getScreenSchemes();
                }
                setFormValues({ visible: false });
            } else if (res?.body?.error_status === true) {
                res?.body?.message && showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const handleEdit = (row, isCopy) => {
        setFormValues((prev) => ({
            ...prev, visible: true, editData: row,
            screen_scheme_name: (isCopy ? `Copy of ${row?.screen_scheme_name}` : row?.screen_scheme_name) || "",
            screen_scheme_description: row?.screen_scheme_description || "",
            default_screen: _.findWhere(options?.screens, { screen_id: row?.default_screen_id }),
            create_screen: _.findWhere(options?.screens, { screen_id: row?.create_screen_id }),
            edit_screen: _.findWhere(options?.screens, { screen_id: row?.edit_screen_id }),
            view_screen: _.findWhere(options?.screens, { screen_id: row?.view_screen_id }),
            isCopy: isCopy
        }))
    }

    const handleChange = (item, e) => {
        setFormValues((prev) => ({ ...prev, [item?.name]: e?.target?.value, isChange: true }));
    }

    const filteredData = useMemo(() => {
        if (!formValues?.search?.trim()) return rowData;
        return rowData?.filter((item) => item?.screen_scheme_name?.toLowerCase()?.includes(formValues?.search.toLowerCase()));
    }, [rowData, formValues?.search]);

    return { formValues, setFormValues, columns, rowData: filteredData, loader, formFields, saveScreenSchemes, handleChange }
}